import payments from "@/services/payments";

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: null,
    payments: {}
  },
  getters: {
    loading: state => state.loading,
    paymentGatewayData: state => state.payments
  },
  mutations: {
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    SET_PAYMENTS(state, paymentsData) {
      state.payments = paymentsData;
    }
  },
  actions: {
    async getPaymentGateway({ commit }) {
      commit("SET_LOADING", true);
      try {
        const { data } = await payments.getPaymentGateway();
        commit("SET_PAYMENTS", data);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    }
  }
};
